import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {filter, map, switchMap} from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";
import {SocietyService} from "@core/shared/services/society.service";
import {UserService} from "@core/shared/services/user.service";
import {User} from "@core/shared/models/user";
import {SocietyValidationAccount, SocietyValidationAccountDialogData, SocietyValidationAccountOrigin} from "@core/shared/models/society-validation-account";
import {ScaValidationRequiredDialogComponent} from "@core/components/sca/sca-validation-required-dialog/sca-validation-required-dialog.component";
import {SCA_VALIDATION_RESPONSE_PATH} from "@core/shared/data/sca";
import {ScaService} from "@core/shared/services/sca.service";

@Injectable({
    providedIn: 'root'
})
export class SocietyValidationAccountGuard implements CanActivate {

    constructor(
        private _dialog: MatDialog,
        private _userService: UserService,
        private _societyService: SocietyService,
        private _scaService: ScaService
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

        if(state.url.startsWith(SCA_VALIDATION_RESPONSE_PATH) || state.url.startsWith('/account/logout')){

            return true;
        }

        return this._userService.currentUser.pipe(
            filter((user: User): boolean => {

                return !!user;
            }),
            switchMap((): Observable<boolean> => {

                const currentUser: User = this._userService.currentUser.getValue();

                if(this._userService.isUserAdmin(currentUser) || !currentUser.societyAdmin){

                    return of(true);
                }

                if(this._societyService.validationAccountStatusChecked){

                    return of(true);
                }

                this._societyService.validationAccountStatusChecked$.next(true);

                return this._societyService.getItemValidationAccountAPI(currentUser.society.id).pipe(
                    map((item: SocietyValidationAccount): boolean => {

                        this._societyService.currentSocietyValidationAccount$.next(item);

                        if(item.isValid){

                            return true;
                        }

                        const data: SocietyValidationAccountDialogData = {
                            origin: SocietyValidationAccountOrigin.Navigation,
                            redirectUrl: item.redirectUrl,
                            returnUrl: this._scaService.getValidationResponseUrl(currentUser.locale)
                        };

                        this._dialog.open(ScaValidationRequiredDialogComponent, {
                            disableClose: true,
                            width: '800px',
                            data: data
                        });

                        return false;
                    })
                );
            }),
        );
    }
}
